<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-12-10 17:44:07
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Claim\ClaimRecord\components\editPaymentStatus.vue
 * @最后编辑: Betway
 * @最后修改时间: 2022-03-07 14:37:35
-->
<template>
  <normalDialog
    :title="$t('label_essweb_ClaimRecord_form_dialog_changePaymentStatusTitle')"
    :dialog="show"
    width="600"
    @close="closeDialog"
    maxWidth="600"
  >
    <template v-slot:content>
      <v-form ref="form" lazy-validation>
        <v-row>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <v-sheet class="mrc_text_require text--secondary">{{
              $t("label_essweb_ClaimRecord_form_dialog_paymentStatusLabel")
            }}</v-sheet>
            <v-autocomplete
              filled
              :items="paymentStatus"
              append-icon="arrow_drop_down"
              item-text="view_fields"
              item-value="value_field"
              dense
              :menu-props="{
                offsetY: true,
                transition: 'slide-y-transition',
                rounded: true,
                contentClass: 'elevation-4',
              }"
              :rules="$GetRules(['_Require_Rules'], [null])"
              v-model="Data.payment_status_uuid"
              single-line
              :placeholder="
                $t('label_essweb_ClaimRecord_form_dialog_paymentStatusLabel')
              "
            >
              <template v-slot:no-data> <noContent /> </template
            ></v-autocomplete>
          </v-col>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <v-sheet class="text--secondary">{{
              $t("label_essweb_ClaimRecord_form_dialog_paymentMethodsLabel")
            }}</v-sheet>
            <v-autocomplete
              filled
              :items="paymentMethods"
              append-icon="arrow_drop_down"
              item-text="view_fields"
              item-value="value_field"
              dense
              :menu-props="{
                offsetY: true,
                transition: 'slide-y-transition',
                rounded: true,
                contentClass: 'elevation-4',
              }"
              v-model="Data.payment_method"
              single-line
              :placeholder="
                $t('label_essweb_ClaimRecord_form_dialog_paymentMethodsLabel')
              "
            >
              <template v-slot:no-data> <noContent /> </template
            ></v-autocomplete>
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <normalInputTextFiled
              v-model="Data.payment_reference"
              :label="
                $t('label_essweb_ClaimRecord_form_dialog_paymentReferenceLabel')
              "
            />
          </v-col>
        </v-row> </v-form
    ></template>
    <template v-slot:actions>
      <CardActions saveBtn @save="toSave" @cancel="closeDialog" />
    </template>
  </normalDialog>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "editpaymentStatusData",
  props: {
    show: { default: false, type: Boolean },
    status: { default: "", type: [Number, String] },
    method: { default: "", type: [Number, String] },
    reference: { default: "", type: [Number, String] },
  },
  computed: {
    ...mapGetters(["defaultUTC"]),
    paymentStatus() {
      return this.$getSelectTrans(this.paymentStatusData, "view_fields");
    },
    paymentMethods() {
      return this.$getSelectTrans(this.paymentMethodsData, "view_fields");
    },
  },
  data() {
    return {
      paymentStatusData: [],
      paymentMethodsData: [],
      Data: {
        payment_status_uuid: "",
        payment_method: "",
        payment_reference: "",
      },
    };
  },
  watch: {
    "Data.payment_status_uuid": function (val) {},
    status(val) {
      this.Data.payment_status_uuid = val;
    },
    method(val) {
      this.Data.payment_method = val;
    },
    reference(val) {
      this.Data.payment_reference = val;
    },
  },
  mounted() {
    this.getpaymentStatus();
    this.getPaymentMthods();
  },
  methods: {
    closeDialog: function () {
      this.$emit("close");
    },
    getpaymentStatus: function () {
      const that = this;
      this.$findPrompt({
        prompt_name: "ess_payment_status_select",
      }).then((res) => {
        that.paymentStatusData = res.data;
      });
    },
    getPaymentMthods: function () {
      const that = this;
      this.$findPrompt({
        prompt_name: "ess_payment_method_select",
      }).then((res) => {
        that.paymentMethodsData = res.data;
      });
    },
    toSave: function () {
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      this.$emit("save", this.Data);
    },
  },
};
</script>